import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './AuthContext';
import Login from './Login';
import AppShell from './AppShell';
import Dashboard from './Dashboard';
import Contatti from './Contatti';
import Pipeline from './Pipeline';
import Attivita from './Attivita';
import Task from './Task';
import Calendario from './Calendario';

export default function App() {
  const { user, loading } = useAuth();
  if (loading) return <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress /></Box>;
  if (!user) return <Login />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/attivita" element={<Attivita />} />
        <Route path="/task" element={<Task />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AppShell>
  );
}